import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import api from "@/lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error("Please enter a valid email address.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative overflow-hidden bg-primary">
      <div className="blob bg-white/25 h-64 w-64 -top-16 -left-10" />
      <div className="blob bg-secondary/40 h-72 w-72 -bottom-24 -right-10" />
      <div className="relative max-w-3xl mx-auto px-5 py-20 text-center text-primary-foreground">
        <Mail className="h-10 w-10 mx-auto mb-4 opacity-90" />
        <h2 className="font-heading text-3xl sm:text-4xl font-bold mb-3">
          Weekly encouragement, straight to your inbox
        </h2>
        <p className="text-primary-foreground/90 mb-8 text-base max-w-xl mx-auto">
          Join thousands of mamas getting practical breastfeeding tips, honest stories, and
          curated product picks. No spam, ever.
        </p>
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            data-testid="newsletter-input"
            className="flex-1 rounded-full px-5 py-3 text-foreground bg-white/95 outline-none focus:ring-2 focus:ring-white"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="rounded-full bg-secondary text-secondary-foreground font-bold px-7 py-3 hover:-translate-y-0.5 transition-transform disabled:opacity-60"
          >
            {loading ? "Joining..." : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
};
